import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { useSelector } from 'react-redux';
import { Text } from 'roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';
import { getMapLinkQueryString } from 'store/search/searchSelectors';
import IconButton from 'components/IconButton';
import { useDataLayer } from 'hooks/useDataLayer';
import AppLink from 'components/AppLink';

const StyledMapSearchButton = styled(IconButton)`
  &:hover {
    color: ${themeGet('colors.white')};
  }
  &:focus {
    outline: 0;
    box-shadow: 0 0 0 1px ${themeGet('colors.blue')};
  }
  ${mediaQuery.minWidth.sm} {
    &:hover {
      color: ${themeGet('colors.greys.charcoal')};
    }
  }
`;

const MapSearchButton = React.memo(() => {
  const { emitInteractionEvent } = useDataLayer();
  const queryString = useSelector(getMapLinkQueryString);
  const mapsLink = { pathname: '/search/map', search: queryString };

  const handleOnClick = useCallback(() => {
    emitInteractionEvent({ type: 'Mobile Fixed Controls', value: 'Map Search Button Selected' });
  }, [emitInteractionEvent]);

  return (
    <StyledMapSearchButton icon="place" to={mapsLink} as={AppLink} onClick={handleOnClick} variant="mobilePillButton">
      <Text fontSize="md">Map</Text>
    </StyledMapSearchButton>
  );
});

MapSearchButton.displayName = 'MapSearchButton';

export default MapSearchButton;
